<template>
  <v-container>
    <h1>{{ verb }} Question Pack</h1>
    <v-sheet color="white" elevation="1" class="px-5 mt-4 rounded">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="submit"
      >
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.name"
              :counter="100"
              :disabled="loading"
              :rules="rules.name"
              label="Name"
              required
            ></v-text-field>
            <v-select
              v-model="form.subject_id"
              :disabled="loading"
              :items="subjects"
              :rules="rules.subject"
              class="mt-4"
              item-text="name"
              item-value="id"
              label="Subject"
            />
            <v-btn
              :disabled="!valid"
              :loading="loading"
              color="success"
              class="mt-8"
              type="submit"
            >
              Submit
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import QuestionPack from "@/services/question-pack";
import Subject from "@/services/subject";

export default {
  name: "QuestionPack.Form",
  data() {
    return {
      valid: false,
      form: {
        name: "",
        subject_id: ""
      },
      subjects: [],
      rules: {
        subject: [v => !!v || "Subject is required"],
        name: [
          v => !!v || "Name is required",
          v =>
            (v.length >= 5 && v.length <= 100) ||
            "Name must be greater than 5 and less then 100",
          v =>
            new RegExp(/^[\w\-\s]+$/i).test(v) ||
            "Name must only contain alphanumeric and whitespace characters"
        ]
      },
      loading: false
    };
  },
  computed: {
    verb() {
      return this.$route.params.id ? "Update" : "Create";
    },
    pastVerb() {
      return `${this.verb}d`;
    },
    dataId() {
      return this.$route.params.id;
    }
  },
  async created() {
    this.setNavbarTitle("Manage Question Pack");
    if (this.dataId) {
      const questionPack = await QuestionPack.find(this.dataId);
      const { name, subjectId: subject_id } = questionPack.data.data;
      this.form = { name, subject_id };
    }
    const subjects = await Subject.index({ paginate: false });
    this.subjects = subjects.data.data.subjects;
  },
  methods: {
    ...mapActions("drawer", ["setNavbarTitle"]),
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          if (this.dataId) {
            await QuestionPack.update(this.dataId, this.form);
          } else {
            await QuestionPack.create(this.form);
          }

          this.$snackbar.showMessage({
            content: `Data ${this.pastVerb.toLowerCase()}`,
            variant: "success"
          });
          this.$router.push({ name: "QuestionPack.Index" });
        } catch (error) {
          this.loading = false;
        }
      }
    }
  }
};
</script>
